// Firebase configuration - REPLACE_WITH_YOUR_... values with your real Firebase project credentials
// IMPORTANT: If you already had real credentials here, make sure they are still in place!
export const firebaseConfig = {
  apiKey: "AIzaSyCIbckoz7DemUJTy4__imfaS4KMyj-xO_k",
  authDomain: "field-sync-d2d6c.firebaseapp.com",
  projectId: "field-sync-d2d6c",
  storageBucket: "field-sync-d2d6c.firebasestorage.app",
  messagingSenderId: "730127104825",
  appId: "1:730127104825:web:dc051fe067917cc61b86e8",

  // --- Zoho Books Integration (Legacy static token) ---
  // Still supported by zoho.js for backward compatibility.
  zohoToken: "YOUR_ZOHO_API_TOKEN",
  zohoOrgId: "20085027987",

  // --- Zoho Books OAuth 2.0 (New) ---
  // NOTE: For a web app, use Zoho API Console directly. Do NOT use
  // "Custom Connection" in Zoho Books — that is for Deluge workflows only
  // and uses dre.zoho.eu/delugeauth/callback (wrong redirect).
  // 1. Create Server-based Client at: https://api-console.zoho.eu/
  // 2. Set Redirect URI: https://login.fieldsync.solutions/zoho-callback
  // 3. client_secret goes in Firebase Functions secrets only!
  zohoClientId: "1000.9K6OTAIRK68FIBRA3UZKQWZELKMZNE",
  zohoDatacenter: "eu",
  zohoRedirectUri: "https://login.fieldsync.solutions/zoho-callback",
  zohoScopes: "ZohoBooks.contacts.READ,ZohoBooks.estimates.READ,ZohoBooks.invoices.READ",
  
  // Cloud Functions region (default: us-central1)
  zohoFunctionsRegion: "us-central1",
};